import axios from "axios";
import { IBooking } from "../../types";
import { ICreateBookingApiParams } from "../types";
import { IGetTotalToBePaidReturn } from "./getTotalToBePaid";

interface IDraftParams {
    draftData: ICreateBookingApiParams['draftData'],
    total: IGetTotalToBePaidReturn
}

interface IDraftReturn {
    code: string;
    data: IBooking;
}

export const draft = async (params: IDraftParams): Promise<IDraftReturn> => {
    const response = await axios.post('/booking/book/draft', params);
    return response.data;
};
